import { Box, CircularProgress, Grid } from '@material-ui/core';
import { StyledCaption } from 'components/Refunds/styles';
import { ShortBody } from 'components/Typography';
import { SizedGridItem } from 'containers/AutoDetailsPage/MyContractsBloc/DownloadFileAutoContracts/styles';
import { isReverse } from 'helpers/intl';
import React from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { getLocaleSelector } from 'store/LanguageProvider/selectors';
import styled from 'styled-components';

const ClaimButton: React.FC<{
  onClick: () => void;
  loading: boolean;
  title: string;
  subtitle?: string;
  buttonTitle: string;
  disabled?: Boolean;
  icon?: any;
  testId?: string;
}> = ({
  loading,
  onClick,
  title,
  buttonTitle,
  disabled,
  icon,
  testId = 'download-pdf-file',
}) => {
  const { formatMessage } = useIntl();
  const lang = useSelector(getLocaleSelector);
  const reverse = isReverse(lang);
  return (
    <Grid item xs={6} sm style={{ paddingRight: 6, paddingLeft: 6 }}>
      <Grid container direction="column">
        <Grid item>
          <StyledCaption>{title}</StyledCaption>
        </Grid>
        <Grid item>
          <Grid item>
            <SizedGridItem style={{ padding: 0 }} item>
              <ItemWrapper
                style={{
                  marginRight: 0,
                  marginLeft: 0,
                  ...((loading || disabled) && {
                    cursor: 'default',
                    opacity: 0.5,
                  }),
                }}
                data-testid={testId}
                onClick={
                  /* istanbul ignore next */ () => {
                    if (loading || disabled) return;
                    /* istanbul ignore next */
                    onClick();
                  }
                }
              >
                {loading ? (
                  <Grid item>
                    <CircularProgress size={15} color="secondary" />
                  </Grid>
                ) : (
                  icon && <Grid item>{icon}</Grid>
                )}
                <StyledCaptions reverse={reverse}>
                  {formatMessage({
                    id: buttonTitle,
                  })}
                </StyledCaptions>
              </ItemWrapper>
            </SizedGridItem>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

const ItemWrapper = styled(({ reverse, ...otherProps }) => (
  <Box {...otherProps} />
))`
  background-color: #e8f3f8;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 10px 20px;
  cursor: pointer;
  margin: 20px;
  &: hover {
    opacity: 0.9;
    background-color: #e8f3f8;
  }
`;

const StyledCaptions = styled(({ reverse, ...otherProps }) => (
  <ShortBody {...otherProps} />
))`
  &&& {
    line-height: 16px;
    margin-bottom: 0px;
    color: #0075c9;
    margin-left: ${(props) => (props.reverse ? '0px' : '6px')};
    margin-right: ${(props) => (props.reverse ? '6px' : '0px')};
  }
`;

export default ClaimButton;
